export const [
  PassengerList,
  PassengerSearch,
  PassengerForm,
  PassportForm,
  PassengerDetails,
] = [1, 2, 3, 4, 5];
